import { t } from "i18next";
import DateValue from "./controls/DateValue";
import TextValue from "./controls/TextValue";
import LinkButton from "./controls/LinkButton";
import DownloadIcon from "./icon/DownloadIcon";
import { ARCHIVOS_ENDPOINT } from "../utils/api";
import { useTramite } from "../context/Tramite";
import { useAuthentication } from "../context/Authentication";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";
import LabeledValue from "./controls/LabeledValue";
import { EstadoTramite, TipoTramite } from "../utils/enums";

export default function InformacionTramite({ ...props }) {
  const { tramite } = useTramite();
  const { token } = useAuthentication();
  return (
    <Grid>
      <Row>
        <Col>
          <LabeledValue
            label={t("tramite.tipo")}
            value={tramite?.tipo}
            labelAttr="nombre"
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <LabeledValue
            label={t("tramite.estado")}
            value={tramite?.estado}
            labelAttr="nombre"
          />
        </Col>
      </Row>
      {[EstadoTramite.PRESENTADO, EstadoTramite.APROBADO].indexOf(
        tramite?.estado?.codigo,
      ) >= 0 && (
        <>
          <Row>
            <Col>
              <DateValue
                label={t(`tramiteForm.estado.${tramite?.estado?.codigo}`)}
                value={tramite?.fechaEstado}
              />
            </Col>
          </Row>
          {tramite?.tipo?.codigo === TipoTramite.DJG && (
            <Row>
              <Col>
                <TextValue
                  label={t("tramite.nivelIncidenciaAmbiental")}
                  value={tramite?.nivelIncidenciaAmbiental}
                />
              </Col>
            </Row>
          )}
          <Row>
            <Col>
              <LinkButton
                style={{ margin: 0, fontSize: "16px" }}
                iconAfter={<DownloadIcon />}
                value={t("tramite.impresion")}
                href={`${ARCHIVOS_ENDPOINT}/${tramite?.impresion?.id}?token=${token}`}
                download={tramite?.impresion?.nombre}
              />
            </Col>
          </Row>
        </>
      )}
    </Grid>
  );
}
